import { Injectable } from '@angular/core';
import { IFlagFeature, IToggleContainer, IFeatureParams } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '@ordersnproducts/features';

@Injectable()
export class NeorisLogoFeature implements IFlagFeature {
  name = Features.NeorisLogo;

  public isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
    return container[this.name].getValue().split(' ').includes(params.customerId.toString());
  }
}
